export class MergeTags {
    public static readonly FIRST_NAME = '{{FIRST_NAME}}';
    public static readonly LAST_NAME = '{{LAST_NAME}}';
    public static readonly EMAIL = '{{EMAIL}}';
    public static readonly JOB_TITLE = '{{JOB_TITLE}}';
    public static readonly COMPANY_NAME = '{{COMPANY_NAME}}';
    public static readonly BOOTH_LOCATION = '{{BOOTH_LOCATION}}';
    public static readonly SESSION_TITLE = '{{SESSION_TITLE}}';
    public static readonly BUZZWAVE_ID = '{{BUZZWAVE_ID}}';
    public static readonly EXTERNAL_ID = '{{EXTERNAL_ID}}';
};
